import { App, createVNode, h, Plugin, render } from 'vue';

import Toasts from '../components/Toasts/Toasts.vue';

export interface ToastsPluginOptions {
  mountNodeClass?: string;
  mountNodeId?: string;
}

export const DEFAULT_TOASTS_PLUGIN_NODE_ID = 'stash-toasts-mount-node';

export default <Plugin>{
  install(app: App, options?: ToastsPluginOptions) {
    const mountNodeId = options?.mountNodeId || DEFAULT_TOASTS_PLUGIN_NODE_ID;
    let mountNode = document.getElementById(mountNodeId);

    if (!mountNode) {
      mountNode = document.createElement('div');
      mountNode.id = mountNodeId;
      mountNode.dataset.test = DEFAULT_TOASTS_PLUGIN_NODE_ID;
      document.body.appendChild(mountNode);
    }

    if (options?.mountNodeClass && !mountNode.classList.contains(options.mountNodeClass)) {
      mountNode.classList.add(options.mountNodeClass);
    }

    const vNode = createVNode(h(Toasts));
    vNode.appContext = app._context;

    render(vNode, mountNode);
  },
};
